import { render, staticRenderFns } from "./ViewAddonSubscriptions.vue?vue&type=template&id=16161b43&scoped=true"
import script from "./ViewAddonSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ViewAddonSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./ViewAddonSubscriptions.vue?vue&type=style&index=0&id=16161b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16161b43",
  null
  
)

export default component.exports